import { FormattedMessage } from "react-intl";
import { Button } from "@/components/design/Button";

// First step of the toplist game: as many categories as a person likes, or
// everything. Chosen categories come first among the suggestions, they do not
// filter them, so even all of them at once is a fine answer.
export function TagsStage({
  question,
  tags,
  chosen,
  onToggle,
  onAll,
  onNext,
}: {
  question: string;
  tags: readonly { code: string; label: string }[];
  chosen: readonly string[];
  onToggle: (code: string) => void;
  onAll: () => void;
  onNext: () => void;
}) {
  return (
    <div id="toplist-tags">
      <h2 className="text-smycles-title font-medium">{question}</h2>
      <p className="mt-1 text-smycles-body text-ink-muted">
        <FormattedMessage id="grow.games.toplist.tags.hint" defaultMessage="Pick as many categories as you like, or everything." />
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <Button
          id="toplist-alltags"
          variant={chosen.length === 0 ? "primary" : "secondary"}
          size="lg"
          aria-pressed={chosen.length === 0}
          onClick={onAll}
        >
          <FormattedMessage id="grow.games.toplist.tags.all" defaultMessage="Everything" />
        </Button>
        {tags.map((tag) => {
          const active = chosen.includes(tag.code);
          return (
            <Button
              id={`toplist-tags-${tag.code}`}
              key={tag.code}
              variant={active ? "primary" : "secondary"}
              size="lg"
              aria-pressed={active}
              onClick={() => onToggle(tag.code)}
            >
              {tag.label}
            </Button>
          );
        })}
      </div>
      <div className="mt-8">
        <Button id="toplist-tagsnext" size="lg" onClick={onNext}>
          <FormattedMessage id="grow.games.toplist.next" defaultMessage="Next" /> <span aria-hidden="true">→</span>
        </Button>
      </div>
    </div>
  );
}
